import { Card, CardContent, Typography, Stack } from '@mui/material';
import type { LabourItemDefinition } from '../../../api/labourItemGroupsApi';

interface GroupLabourItemsCardProps {
  labourItems: LabourItemDefinition[];
}

export function GroupLabourItemsCard({
  labourItems,
}: GroupLabourItemsCardProps) {
  return (
    <Card variant="outlined" data-testid="group-labour-items-card">
      <CardContent>
        <Stack spacing={2}>
          {/* Card Title */}
          <Typography variant="h6" component="h3">
            Labour Items
          </Typography>

          {/* Explanatory Text */}
          <Typography variant="body2" color="text.secondary">
            This group determines which labour items users can see when booking
            labour. Items are assigned when creating the group.
          </Typography>

          {/* Labour Items List */}
          {!labourItems || labourItems.length === 0 ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontStyle: 'italic' }}
            >
              No labour items assigned to this group
            </Typography>
          ) : (
            <Stack spacing={1}>
              {labourItems.map(item => (
                <Typography
                  key={item.id}
                  variant="body2"
                  data-testid={`group-item-${item.id}`}
                >
                  {item.name}
                </Typography>
              ))}
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
